import { render, staticRenderFns } from "./FooterCopyright.vue?vue&type=template&id=0ad4d8b8&scoped=true&"
import script from "./FooterCopyright.vue?vue&type=script&lang=js&"
export * from "./FooterCopyright.vue?vue&type=script&lang=js&"
import style0 from "./FooterCopyright.vue?vue&type=style&index=0&id=0ad4d8b8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad4d8b8",
  null
  
)

export default component.exports